export function setTokenInvalidGlobal(value) {
  if (typeof window !== 'undefined') {
    window.__setTokenInvalid = value;
    window.dispatchEvent(new CustomEvent('tokenInvalidChanged', { detail: value }));
  }
}
